import { SpreadToolsComponent } from '../../components/attribute-view/spread-tools/spread-tools.component';
import { MapComponent } from '../../components/map/map.component';
import { ActionMap } from '../../services/action-handler.service';
import { SLVApp } from '../../types/@types/sl-v-types';
import { SLContext } from '../../types/sl-context';
import { TestContext } from '../../types/test-context';
import { SLMap } from '../sl-map';

export class SpreadActions {
  private static app: SLVApp;
  public static components: any = {};
  public static SetApp(app) {
    SpreadActions.app = app;
  }
  public static Exec(command: string, map: MapComponent, data: any) {
    const commandParts = command.split('-');
    let exec = '';
    commandParts.every((val) => {
      exec += val[0].toUpperCase() + val.substring(1).toLowerCase();
      return true;
    })
    if (SpreadActions[exec]) {
      SpreadActions[exec](map, data[0]);
    }
  }
  public static RegisterComponent(name: string, component: any) {
    SpreadActions.components[name] = component;
  }
  public static GetSpreadToolsComponent(): undefined | SpreadToolsComponent {
    if (!SpreadActions.components['spread-tools']) return undefined;
    return SpreadActions.components['spread-tools'];
  }
  public static SetSpreadTool(tool: string, params:{ enabled: boolean, map: SLMap }) {
    SpreadActions.GetSpreadToolsComponent()?.SetTool(tool, params);
  }
  public static RegisterActions(actions: ActionMap): ActionMap {
    actions['spread-actions/spread-tools'] = {
      name: 'Vertex Spread Tools',
      handler: (context: SLContext | TestContext, ...args: any) => {
        SpreadActions.Exec('spread-tools', context.map.component, args);
      }
    }
    actions['spread-actions/spread-distribute'] = {
      name: 'Spread vertices between two slected vertices evenly',
      handler: (context: SLContext | TestContext, ...args: any) => {
        SpreadActions.Exec('spread-distribute', context.map.component, args);
      }
    }
    actions['spread-actions/split-distance'] = {
      name: 'Split a selected segment into subsegments by distance',
      handler: (context: SLContext | TestContext, ...args: any) => {
        SpreadActions.Exec('split-distance', context.map.component, args);
      }
    }
    actions['spread-actions/split-number'] = {
      name: 'Split a selected segment into a specified number of subsegments',
      handler: (context: SLContext | TestContext, ...args: any) => {
        SpreadActions.Exec('split-number', context.map.component, args);
      }
    }
    actions['spread-actions/split-at'] = {
      name: 'Split a selected segment at its midpoint',
      handler: (context: SLContext | TestContext, ...args: any) => {
        SpreadActions.Exec('split-at', context.map.component, args);
      }
    }
    return actions;
  }
  public static SpreadDistribute(map:MapComponent, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    SpreadActions.SetSpreadTool('spread-distribute', { enabled: isOn, map: map.SLMap })
  }
  public static SplitDistance(map:MapComponent, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    SpreadActions.SetSpreadTool('split-distance', { enabled: isOn, map: map.SLMap })
  }
  public static SplitNumber(map:MapComponent, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    SpreadActions.SetSpreadTool('split-number', { enabled: isOn, map: map.SLMap })
  }
  public static SplitAt(map:MapComponent, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    SpreadActions.SetSpreadTool('split-at', { enabled: isOn, map: map.SLMap })
  }

}
